<div class="active-call-modal" *ngIf="show" [class.active]="show"
	[style.top.px]="hasMoved ? popupPos.y : null" [style.left.px]="hasMoved ? popupPos.x : null"
	[style.align-items]="hasMoved ? 'flex-start' : 'center'"
	[style.justify-content]="hasMoved ? 'flex-start' : 'center'">

  <div class="cw-root" (mousedown)="onDragStart($event)">
    <!-- Identity -->
    <div class="cw-identity">
      <span class="cw-phase">{{ phaseLabel }}</span>
      <h2 class="cw-name">{{ caller?.name || 'Contact' }}</h2>
      <p class="cw-sub">{{ subLabel }}</p>
    </div>

    <!-- Stage 320x320 -->
    <div class="cw-stage">
      <div class="cw-pulse cw-pulse--purple" [class.paused]="!pulseActive"></div>
      <div class="cw-pulse cw-pulse--green" [class.paused]="!pulseActive"></div>

      <!-- INCOMING BUTTONS -->
      <ng-container *ngFor="let btn of incomingBtns; trackBy: trackById">
        <div class="cw-arc-wrap" [style.opacity]="incomingOpen ? 1 : 0" [style.pointer-events]="incomingOpen ? 'auto' : 'none'" [style.transform]="btnTransform(btn, incomingOpen)" [style.transition]="btnTransition(btn.delay)">
          <button class="cw-abtn" [style.background]="btn.bg" [class.pulse-red]="btn.pulseClass === 'pulse-red'" [class.pulse-green]="btn.pulseClass === 'pulse-green'" [class.pulse-blue]="btn.pulseClass === 'pulse-blue'" (click)="handleIncoming(btn.id)">
            <span class="material-symbols-outlined" [style.color]="btn.color">{{ btn.icon }}</span>
          </button>
          <span class="cw-alabel" [style.color]="btn.color">{{ btn.label }}</span>
        </div>
      </ng-container>

      <!-- Main bubble -->
      <div class="cw-bubble cw-bubble--clickable" [style.box-shadow]="bubbleGlow" [style.transform]="bubbleTransform" (click)="onBubbleTap()">
        <img [src]="getProfileImage(caller)" class="cw-img" />
      </div>
    </div><!-- /stage -->

    <div class="cw-pill">
      <div class="cw-dot"></div>
      <span class="cw-stxt">{{ statusText }}</span>
    </div>

    <div class="cw-progress" [class.visible]="menuOpen">
      <div class="cw-progress-fill" [class.running]="menuOpen" [style.transition-duration]="progressDuration"></div>
    </div>

    <p class="cw-hint" [class.hidden]="menuOpen">Tap bubble to answer</p>

  </div>

</div>